import { db } from '../config/firebase';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';

interface UserSettings {
  darkMode: boolean;
  // Add more settings here as needed
}

const defaultSettings: UserSettings = {
  darkMode: false,
};

export const settingsService = {
  async getUserSettings(userId: string): Promise<UserSettings> {
    try {
      const settingsDoc = await getDoc(doc(db, 'userSettings', userId));
      if (!settingsDoc.exists()) {
        // Initialize default settings for new users
        await setDoc(doc(db, 'userSettings', userId), defaultSettings);
        return defaultSettings;
      }
      return settingsDoc.data() as UserSettings;
    } catch (error) {
      
      return defaultSettings;
    }
  },

  async updateUserSettings(userId: string, settings: Partial<UserSettings>): Promise<void> {
    try {
      const settingsRef = doc(db, 'userSettings', userId);
      await updateDoc(settingsRef, settings);
    } catch (error) {
      
      throw error;
    }
  },

  async toggleDarkMode(userId: string, isDarkMode: boolean): Promise<void> {
    return this.updateUserSettings(userId, { darkMode: isDarkMode });
  }
};
